import React from 'react';
import { ImageOff } from 'lucide-react';
import './ProductImagePlaceholder.css';

interface ProductImagePlaceholderProps {
  label: string;
  className?: string;
}

const ProductImagePlaceholder: React.FC<ProductImagePlaceholderProps> = ({ label, className = '' }) => (
  <div
    className={`product-image-placeholder ${className}`.trim()}
    role="img"
    aria-label={label}
  >
    <span className="product-image-placeholder-icon" aria-hidden="true">
      <ImageOff />
    </span>
    <span>{label}</span>
  </div>
);

export default ProductImagePlaceholder;
